// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NHl-j","statusCell":"styles_statusCell__90aLl"};